<template>
  <div id="loading-overlay">
    <v-dialog v-model="loadingOverlay.is_loading" fullscreen persistent>
        <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
          <v-layout justify-center align-center>
            <v-progress-circular
              indeterminate
              :size="70"
              color="#207EA9"
            >
            </v-progress-circular>
          </v-layout>
        </v-container>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {i18n} from "@/i18n";

export default {
name: "LoadingOverlay",
  computed: {
    ...mapGetters(['loadingOverlay']),
  },
  created() {
    this.$store.state.loading_overlay.timer = setTimeout(() => {
      this.$store.dispatch('setSnackbar', {text: i18n.t('notifications.common.system_reboot_timeout')})
      this.$store.dispatch('updateLoadingOverlay', {is_loading: false, reload_required: false})
    }, this.loadingOverlay.loading_timeout)
  }
}
</script>

<style scoped>

</style>